import { apiInterfaceForJson, apiInterfaceForFormData } from "../common/apiManager";
import axios from "axios";
import { serviceConstants } from "../common/constants";
import { getUserAuthToken } from "../common/util";

export const fetchLeads = () => {
    return apiInterfaceForJson("/lead/v1/", "GET");
};

export const fetchAvailableLeads = (page = 1, limit = 100, filters = {}, sortConfig) => {
    // Build query string with pagination and filters
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("limit", limit.toString());
    
    // Add filters to query string
    if (filters.searchTerm) {
        params.append("searchTerm", filters.searchTerm);
    }
    if (filters.statuses && filters.statuses.length > 0) {
        filters.statuses.forEach(status => params.append("statuses", status));
    }
    if (filters.excludeStatuses && filters.excludeStatuses.length > 0) {
        filters.excludeStatuses.forEach(status => params.append("excludeStatuses", status));
    }
    if (filters.country && filters.country.length > 0) {
        filters.country.forEach(country => params.append("country", country));
    }
    if (filters.excludeCountries && filters.excludeCountries.length > 0) {
        filters.excludeCountries.forEach(country => params.append("excludeCountries", country));
    }
    if (filters.desk && filters.desk.length > 0) {
        filters.desk.forEach(desk => params.append("desk", desk));
    }
    if (filters.agent && filters.agent.length > 0) {
        filters.agent.forEach(agent => params.append("agent", agent));
    }
    if (filters.floorManager && filters.floorManager.length > 0) {
        filters.floorManager.forEach(fm => params.append("floorManager", fm));
    }
    if (filters.source && filters.source.length > 0) {
        filters.source.forEach(source => params.append("source", source));
    }
    if (filters.affiliate && filters.affiliate.length > 0) {
        filters.affiliate.forEach(affiliate => params.append("affiliate", affiliate));
    }
    if (filters.hasAffiliate === true) {
        params.append("hasAffiliate", "true");
    }
    if (filters.isLive !== undefined && filters.isLive !== null) {
        params.append("isLive", filters.isLive);
    }
    if (filters.registeredFrom) {
        params.append("registeredFrom", filters.registeredFrom);
    }
    if (filters.registeredTo) {
        params.append("registeredTo", filters.registeredTo);
    }

    // Optional server-side sorting (used on main Leads page)
    if (sortConfig && sortConfig.key) {
        params.append("sortKey", sortConfig.key);
        if (sortConfig.direction) {
            params.append("sortDirection", sortConfig.direction);
        }
    }
    
    return apiInterfaceForJson(`/lead/v1/available?${params.toString()}`, "GET");
};

export const fetchAvailableLeadIds = (filters = {}) => {
    // Build query string with filters (for fetching only IDs)
    const params = new URLSearchParams();
    
    // Add filters to query string
    if (filters.searchTerm) {
        params.append("searchTerm", filters.searchTerm);
    }
    if (filters.statuses && filters.statuses.length > 0) {
        filters.statuses.forEach(status => params.append("statuses", status));
    }
    if (filters.excludeStatuses && filters.excludeStatuses.length > 0) {
        filters.excludeStatuses.forEach(status => params.append("excludeStatuses", status));
    }
    if (filters.country && filters.country.length > 0) {
        filters.country.forEach(country => params.append("country", country));
    }
    if (filters.excludeCountries && filters.excludeCountries.length > 0) {
        filters.excludeCountries.forEach(country => params.append("excludeCountries", country));
    }
    if (filters.desk && filters.desk.length > 0) {
        filters.desk.forEach(desk => params.append("desk", desk));
    }
    if (filters.agent && filters.agent.length > 0) {
        filters.agent.forEach(agent => params.append("agent", agent));
    }
    if (filters.floorManager && filters.floorManager.length > 0) {
        filters.floorManager.forEach(fm => params.append("floorManager", fm));
    }
    if (filters.source && filters.source.length > 0) {
        filters.source.forEach(source => params.append("source", source));
    }
    if (filters.affiliate && filters.affiliate.length > 0) {
        filters.affiliate.forEach(affiliate => params.append("affiliate", affiliate));
    }
    if (filters.isLive !== undefined && filters.isLive !== null) {
        params.append("isLive", filters.isLive);
    }
    if (filters.registeredFrom) {
        params.append("registeredFrom", filters.registeredFrom);
    }
    if (filters.registeredTo) {
        params.append("registeredTo", filters.registeredTo);
    }
    
    return apiInterfaceForJson(`/lead/v1/available/ids?${params.toString()}`, "GET");
};

export const fetchDistinctValues = (field) => {
    // Fetch distinct values for a field (source, affiliate, country)
    return apiInterfaceForJson(`/lead/v1/distinct?field=${field}`, "GET");
};

export const fetchCountriesBySourceAffiliate = (source = [], affiliate = []) => {
    // Fetch countries with counts, filtered by source and/or affiliate only
    const params = new URLSearchParams();
    
    if (source && source.length > 0) {
        source.forEach(s => params.append("source", s));
    }
    
    if (affiliate && affiliate.length > 0) {
        affiliate.forEach(a => params.append("affiliate", a));
    }
    
    return apiInterfaceForJson(`/lead/v1/countries-by-source-affiliate?${params.toString()}`, "GET");
};

export const fetchStatusesBySourceAffiliate = (source = [], affiliate = []) => {
    // Fetch statuses with counts, filtered by source and/or affiliate only
    const params = new URLSearchParams();
    
    if (source && source.length > 0) {
        source.forEach(s => params.append("source", s));
    }
    
    if (affiliate && affiliate.length > 0) {
        affiliate.forEach(a => params.append("affiliate", a));
    }
    
    return apiInterfaceForJson(`/lead/v1/statuses-by-source-affiliate?${params.toString()}`, "GET");
};

export const fetchSourcesByAffiliate = (affiliate = []) => {
    // Fetch sources filtered by affiliate only
    const params = new URLSearchParams();
    
    if (affiliate && affiliate.length > 0) {
        affiliate.forEach(a => params.append("affiliate", a));
    }
    
    return apiInterfaceForJson(`/lead/v1/sources-by-affiliate?${params.toString()}`, "GET");
};

export const saveCallLog = (callLog) => {
    return apiInterfaceForJson("/lead/v1/saveCallLog", "POST", callLog);
};

export const searchLeads = (query) => {
    return apiInterfaceForJson("/lead/v1/search", "POST", query);
};

export const getLeadDataById = (leadId) => {
    return apiInterfaceForJson("/lead/v1/" + leadId, "GET");
};

export const createLead = (leadDetails) => {
    return apiInterfaceForJson("/lead/v1/", "POST", leadDetails);
};

export const createLeadBatch = (batchDetails, duplicateCheckEnabled) => {
    // Pass duplicateCheckEnabled as a URL query param so the request body stays
    // as a plain array (no format change, no parsing ambiguity).
    const url = duplicateCheckEnabled !== undefined
        ? `/lead/v1/batch?duplicateCheckEnabled=${duplicateCheckEnabled}`
        : "/lead/v1/batch";
    return apiInterfaceForJson(url, "POST", batchDetails);
};

export const createLeadComment = (commentDetails) => {
    return apiInterfaceForJson("/lead/v1/comment", "POST", commentDetails);
};

export const deleteLeadComment = (commentDetails) => {
    return apiInterfaceForJson("/lead/v1/comment", "DELETE", commentDetails);
};

export const updateLead = (leadDetails) => {
    return apiInterfaceForJson("/lead/v1/", "PUT", leadDetails);
};

export const deleteLead = (leadDetails) => {
    return apiInterfaceForJson("/lead/v1/delete", "POST", leadDetails);
};

export const bulkUpdateLeads = (updateData) => {
    return apiInterfaceForJson("/lead/v1/bulk-update", "POST", updateData);
};

export const bulkAssignLeads = (assignData) => {
    return apiInterfaceForJson("/lead/v1/bulk-assign", "POST", assignData);
};

export const shufflePreview = (previewData) => {
    return apiInterfaceForJson("/lead/v1/shuffle-preview", "POST", previewData);
};

export const shuffleLeads = (shuffleData) => {
    return apiInterfaceForJson("/lead/v1/shuffle", "POST", shuffleData);
};


export const uploadScreenshots = (leadId, files) => {
    const formData = new FormData();
    formData.append("leadId", leadId);
    files.forEach((file) => {
        formData.append("screenshots", file);
    });
    
    return apiInterfaceForFormData(`/lead/v1/${leadId}/screenshots`, "POST", formData);
};

export const deleteScreenshot = (leadId, screenshotId) => {
    return apiInterfaceForJson(`/lead/v1/${leadId}/screenshots/${screenshotId}`, "DELETE");
};

export const exportLeadsToExcel = async (sources = [], countries = [], leadIds = []) => {
    // Use POST with JSON body — query strings break around 8KB which is hit
    // quickly when exporting selected leads (each ObjectId is 24 chars).
    const response = await axios.post(
        `${serviceConstants.API_HOST_NAME}/lead/v1/export`,
        { sources, countries, leadIds },
        {
            headers: {
                Authorization: "Bearer " + getUserAuthToken(),
                "Content-Type": "application/json"
            },
            responseType: "blob",
            // Big selections can take a while server-side
            timeout: 5 * 60 * 1000
        }
    );

    // Trigger browser download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    let filename;
    if (leadIds.length) {
        filename = `leads_selected_${leadIds.length}_${Date.now()}.xlsx`;
    } else {
        const parts = [];
        if (sources.length) parts.push(`src_${sources.join("_")}`);
        if (countries.length) parts.push(`cty_${countries.join("_")}`);
        filename = parts.length
            ? `leads_${parts.join("_")}_${Date.now()}.xlsx`
            : `leads_all_${Date.now()}.xlsx`;
    }
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};